import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import MaterialTable from "material-table";
import CardBody from "components/Card/CardBody.jsx";

import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete';
import OKIcon from '@material-ui/icons/CheckCircleOutline'

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import "../Dashboard/dashboard.css";

import axios from 'axios'
import conf from '../../conf.json'

class ApproveUser extends React.Component {
  state = {
    value: 0,
    users_data: []
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  constructor(props){
    super(props);
    this.getUserApprove();
    this.aproveUser = this.aproveUser.bind(this);
  }
  getUserApprove(){
    const params = {
      token: localStorage.getItem("token")
    };
    axios
      .post(conf.url + "/approve/get" , JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        //console.log(res)
        this.setState({
          users_data: res.data.data
        })
      })
  }
  aproveUser(username,status) {
   let url = ""
    if(status === "Y"){
      url =conf.url + "/approve/y"
    }else{
      url =conf.url + "/approve/n"
    }
    const params = {
      token: localStorage.getItem("token"),
      user: username
    };
    axios
      .post(url , JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res=>{
        this.getUserApprove();
      })
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>
                  รายการอนุมัติบัญชีผู้ใช้งาน
                </h4>
                <p className={classes.cardCategoryWhite}>
                  ตารางแสดงรายการอนุมัติสิทธิของบัญชีผู้ใช้งานต่างๆ
                </p>
              </CardHeader>
              <CardBody>
                <MaterialTable
                  title="ประวัติการเปลี่ยนแปลง"
                  columns={[
                    {
                      title: "Username",
                      field: "acusername",
                      defaultSort: "desc"
                    },
                    {
                      title: "ชื่อ",
                      field: "acfirstname"
                    },
                    {
                      title: "นามสกุล",
                      field: "aclastname"
                    },
                    {
                      title: "ตำแหน่ง",
                      render: rowdata => {
                        if(rowdata.acstatus === "1"){
                          return (
                            "Call Center"
                          );
                        }else if(rowdata.acstatus === "2"){
                          return (
                            "Admin Call Center"
                          );
                        }else if(rowdata.acstatus === "3"){
                          return (
                            "Admin Sale"
                          );
                        }else if(rowdata.acstatus === "4"){
                          return (
                            "Sale"
                          );
                        }else{
                          return (
                            "Super Admin"
                          );
                        }
                       
                      }
                    },
                    { 
                      render: rowdata => {
                        return (
                          <div>
                            <Button onClick={()=>this.aproveUser(rowdata.acusername,"Y")} style={{marginRight:20}} variant="contained" color="primary" className={classes.button}>
                                อนุมัติ
                                <OKIcon className={classes.rightIcon} />
                            </Button>
                             
                             <Button onClick={()=>this.aproveUser(rowdata.acusername,"N")} variant="contained" color="secondary" className={classes.button}>
                                ปฏิเสธ
                                <DeleteIcon className={classes.rightIcon} />
                            </Button>
                          </div>
                        );
                    }
                    }
                  ]}
                  data={this.state.users_data}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ApproveUser.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(ApproveUser);



// WEBPACK FOOTER //
// ./src/views/ApproveUser/ApproveUser.jsx